/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsRegion {
    getFixupPrototypeFunction() { return AwsRegion.fixupPrototype; }

    static newInstance(model: Partial<AwsRegion>): AwsRegion {
        let obj = Object.assign(new AwsRegion(), model);
        AwsRegion.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsRegion>): AwsRegion {
        if (!model) return null;
        return AwsRegion.newInstance(<AwsRegion> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsRegion) {
        if (!obj) return;

        models.AwsRegion.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsRegion): boolean {
        Object.setPrototypeOf(obj, AwsRegion.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Name for region
     */
    name: string;

    /**
     * Id for region
     */
    id: string;

}
